import { CAGEDGame, type CAGEDGameType } from '@tunasong/games'
import { VendorServices } from '@tunasong/vendor'
import { SEO } from '../components/seo.js'
import SignupButton from '../components/signup-button.js'

const game: CAGEDGameType = {
  id: 'public-fret-note-game',
  name: 'Fretboard CAGED Game',
  description: 'Practice and master the CAGED system shapes on the guitar fretboard.',
  gameId: 'CAGED',
  type: 'game',
}

const boxBackground = 'bg-gray-700/30'

export const GamesPage = () => (
  <main className="flex flex-col flex-1 bg-gradient-to-b from-[#000000] via-[#2a1740] to-[#301b41]">
    <SEO title="Tuna games" />
    <VendorServices>
      <section className="flex flex-col items-center justify-center min-h-[70vh] px-4">
        <div className="mb-10"></div>
        <div className={` text-4xl md:text-5xl font-bold text-white mb-5`}>Fretboard CAGED Game</div>
        <p className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto">
          Practice and master the CAGED system shapes on the guitar fretboard.
        </p>

        <div
          className={`${boxBackground} mt-10 w-full max-w-3xl black/90 rounded-2xl shadow-2xl p-8 flex flex-col flex-1 items-center`}
        >
          <CAGEDGame sx={{ width: '100%' }} game={game} />
        </div>
      </section>
      <section className="mt-12 flex flex-col items-center">
        <div className={`${boxBackground} rounded-xl px-6 py-4 shadow-md max-w-md text-center`}>
          <p className="text-gray-100 text-base mb-10">
            Enjoying the game? <span className="font-semibold">Sign up</span> to the Tunasong platform to save your
            progress to games across devices. Oh - and unlock tons of features for you as a musician, songwriter,
            bandmember, or music teacher.
          </p>
          <SignupButton />
        </div>
      </section>
    </VendorServices>
  </main>
)
